// Navigation actions
/* eslint-disable */
import types from '../../types';

export default {
  [types.OPEN_NAVIGATION]: (context) => {
    context.commit('OPEN_NAVIGATION');
  },
  [types.CLOSE_NAVIGATION]: (context) => {
    context.commit('CLOSE_NAVIGATION');
  },
  [types.SET_ACTIVE_MENU]: (context, payload) => {
    context.commit('SET_ACTIVE_MENU', payload);
  },
  [types.OPEN_LEFT_NAVIGATION]: (context) => {
    context.commit('OPEN_LEFT_NAVIGATION');
  },
  [types.CLOSE_LEFT_NAVIGATION]: (context) => {
    context.commit('CLOSE_LEFT_NAVIGATION');
  },
  [types.SET_LEFT_ACTIVE_MENU]: (context, payload) => {
    context.commit('SET_LEFT_ACTIVE_MENU', payload);
  },
};
